var map = {
	"./MSMLogoTwoLines.svg": "cf93",
	"./MSMLogoTwoLinesMobile.svg": "aafd",
	"./Powered-by-Bionic-mobile.svg": "beb2",
	"./Powered-by-Bionic.svg": "6b63",
	"./Poweredby_BroadbandChoices2.svg": "3285",
	"./bionic-logo-dark.svg": "261d",
	"./bionic-logo-light.svg": "849c",
	"./compareTheMarketLogo.svg": "e516",
	"./compareTheMarketMobileLogo.svg": "5181",
	"./mic-logo-dark.svg": "1d7a",
	"./mic-logo-light.svg": "70da",
	"./msm-long.svg": "1642",
	"./partners/confused-logo.svg": "b599",
	"./partners/msm-logo.png": "d084",
	"./partners/uswitch-logo.png": "45a6",
	"./provided-by-logo.svg": "3ca0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe02";